import { RsvpsGeneralScreenProps } from "navigation/types";
import { useFetchRsvpEventsQuery } from "queries/rsvp.queries";
import React from "react";
import { ActivityIndicator, Text, View } from "react-native";
import PlayerIdForm from "./components/PlayerIdForm";
import RsvpEventHeader from "./components/RsvpEventHeader";
import RsvpEventImage from "./components/RsvpEventImage";
import RsvpMessage from "./components/RsvpMessage";
import RsvpScaffold from "./components/RsvpScaffold";
import { useRsvpColors } from "./theme";

const RsvpsGeneral = (props: RsvpsGeneralScreenProps) => {
  const {
    navigation,
    route: {
      params: { eventSlug },
    },
  } = props;

  const colors = useRsvpColors();
  const {
    data: events,
    isLoading,
    isError,
  } = useFetchRsvpEventsQuery(eventSlug);

  if (isLoading) {
    return (
      <RsvpScaffold>
        <View style={{ alignItems: "center" }}>
          <ActivityIndicator size="large" color={colors.accent} />
        </View>
      </RsvpScaffold>
    );
  }

  if (isError || !events || events.length === 0) {
    return (
      <RsvpMessage
        icon="alert-circle"
        tone="danger"
        title="We couldn't find this event."
        body="Please check your link and try again."
      />
    );
  }

  const handleSubmit = (playerId: string) => {
    navigation.navigate("RsvpsPersonal", {
      eventSlug,
      playerId,
    });
  };

  // Events sharing a slug may not all have an image; show the first one that does
  const eventImageUrl = events.find((e) => e.eventImageUrl)?.eventImageUrl;

  return (
    <RsvpScaffold>
      <RsvpEventImage url={eventImageUrl} />
      {/* Events sharing a slug have the same name; show name/venue without
          dates — the player picks the specific event on the personal page
          after entering their ID */}
      <RsvpEventHeader event={events[0]} showDate={false} />

      <Text
        style={{
          color: colors.textMuted,
          fontSize: 15,
          marginBottom: 16,
        }}
      >
        Enter your Player ID to continue.
      </Text>

      <PlayerIdForm onSubmit={handleSubmit} />
    </RsvpScaffold>
  );
};

export default RsvpsGeneral;
